import { Alert, Box } from '@mui/material';
import { EmbeddedValueContentTab } from 'app/pages/ContentManagementPage/components/valueContent/ValueContentTab';

type DealerValuesEntityPanelProps = {
  dealerId: string;
  allowedIds: string[];
};

export default function DealerValuesEntityPanel({
  dealerId,
  allowedIds,
}: DealerValuesEntityPanelProps) {
  if (!allowedIds.length) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        No dealer value IDs were provided for this attention row.
      </Alert>
    );
  }

  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to view dealer values.
      </Alert>
    );
  }

  return (
    <Box sx={{ minHeight: 0, flex: 1, overflow: 'hidden' }}>
      <EmbeddedValueContentTab embedded allowedRowIds={allowedIds} />
    </Box>
  );
}

